var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-container',[_c('b-row',[(_vm.text)?_c('b-col',{attrs:{"lg":"9","offset-lg":"1"}},[_c('div',{staticClass:"text-block"},[_c('options-fields-inline-editor',{attrs:{"component":_vm.component,"keyOption":_vm.text,"value":_vm.text}})],1)]):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }